import { curPage, showShareDialog, sendBack } from './boot.js';
import { apiRoutes } from './apiRoutes.js';
import { authenticatedFetch } from './auth/authSession.js';
import { buildCodelyLaunchUrl } from './codelyActivityLaunch.js';
import { fetchCodelyShare } from './codelyShareApi.js';
import { createJsonFile, exportFileName, uploadCodelyFile } from './codelyFileUpload.js';
import {
  getAuthoredInstructionHtml,
  setAuthoredInstructionHtml,
} from './codelyInstructionState.js';
import { initializeVernatiicsModal, setupVernatiicsEventHandlers } from './vernatics.js';
import { navigationIcons } from './img_sound_imports.js';
import { createIcons, icons } from 'lucide';
import { createModal } from '@/scripts/UI/modal.js';
import { createShareModal } from '@/scripts/UI/shareModal.js';
import { setupGameModals } from '@/scripts/UI/gameModals.js';
import { createVernaticsModal } from '@/scripts/UI/vernaticsModal.js';
import {
  sequence_loss_sound,
  imgactivity1,
  imgactivity2,
  imgactivity3,
  imgactivity4,
  imgactivity5,
  imgactivity6,
  imgactivity7,
  imgactivity8,
  imgactivity9,
  imgactivity10,
  imgactivity11,
  imgactivity12,
  imgactivity13,
  imgactivity14,
  imgactivity15,
  imgactivity16,
  imgactivity17,
  imgactivity18,
  imgactivity19,
  imgactivity20,
  imgactivity21,
  imgactivity22,
  imgactivity23,
  imgactivity24,
  imgactivity25,
  imgactivity26,
  imgactivity27,
  imgactivity28,
  imgactivity1NoBg,
  imgactivity2NoBg,
  imgactivity3NoBg,
  imgactivity4NoBg,
  imgactivity5NoBg,
  imgactivity6NoBg,
  imgactivity7NoBg,
  imgactivity8NoBg,
  imgactivity9NoBg,
  imgactivity10NoBg,
  imgactivity11NoBg,
  imgactivity12NoBg,
  imgactivity13NoBg,
  imgactivity14NoBg,
  imgactivity15NoBg,
  imgactivity16NoBg,
  imgactivity17NoBg,
  imgactivity18NoBg,
  imgactivity19NoBg,
  imgactivity20NoBg,
  imgactivity21NoBg,
  imgactivity22NoBg,
  imgactivity23NoBg,
  imgactivity24NoBg,
  imgactivity25NoBg,
  imgactivity26NoBg,
  imgactivity27NoBg,
  imgactivity28NoBg,
  bot_img,
} from './img_sound_imports.js';
console.log(
  sequence_loss_sound,
  imgactivity1,
  imgactivity2,
  imgactivity3,
  imgactivity4,
  imgactivity5,
  imgactivity6,
  imgactivity7,
  imgactivity8,
  imgactivity9,
  imgactivity10,
  imgactivity11,
  imgactivity12,
  imgactivity13,
  imgactivity14,
  imgactivity15,
  imgactivity16,
  imgactivity17,
  imgactivity18,
  imgactivity19,
  imgactivity20,
  imgactivity21,
  imgactivity22,
  imgactivity23,
  imgactivity24,
  imgactivity25,
  imgactivity26,
  imgactivity27,
  imgactivity28,
  imgactivity1NoBg,
  imgactivity2NoBg,
  imgactivity3NoBg,
  imgactivity4NoBg,
  imgactivity5NoBg,
  imgactivity6NoBg,
  imgactivity7NoBg,
  imgactivity8NoBg,
  imgactivity9NoBg,
  imgactivity10NoBg,
  imgactivity11NoBg,
  imgactivity12NoBg,
  imgactivity13NoBg,
  imgactivity14NoBg,
  imgactivity15NoBg,
  imgactivity16NoBg,
  imgactivity17NoBg,
  imgactivity18NoBg,
  imgactivity19NoBg,
  imgactivity20NoBg,
  imgactivity21NoBg,
  imgactivity22NoBg,
  imgactivity23NoBg,
  imgactivity24NoBg,
  imgactivity25NoBg,
  imgactivity26NoBg,
  imgactivity27NoBg,
  imgactivity28NoBg
);
import * as Blockly from 'blockly';
import { currLang } from './translation.js';
import {
  showErrorMsg,
  showSuccessMsg,
  addDesignToModal,
  initializeWorkspaceScrollbarVisibility,
} from '@/scripts/helpers/common_helpers.js';
import { showToast } from '@/scripts/helpers/toast_helpers.js';
import { classNameObj, functionNameObj } from './config_python.js';
import * as JsGenerator from 'blockly/javascript';
import { w3CodeColor } from './w3codecolor.js';
import { pythonGenerator } from 'blockly/python';
import loadedCdn from '@/scripts/helpers/cdnLoadingScript.js';
import {
  ClassicEditor,
  Alignment,
  AutoImage,
  AutoLink,
  Autosave,
  Bold,
  Code,
  CodeBlock,
  Essentials,
  Heading,
  ImageBlock,
  ImageInsert,
  ImageInsertViaUrl,
  ImageToolbar,
  ImageUpload,
  Indent,
  IndentBlock,
  Italic,
  Link,
  List,
  Mention,
  Paragraph,
  PasteFromOffice,
  SelectAll,
  Underline,
  Undo,
} from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import { activityImages } from '@/scripts/img_sound_imports.js';
let blocksData, intialCodeData;
const editorConfig = {
  toolbar: {
    items: [
      'undo',
      'redo',
      '|',
      'selectAll',
      '|',
      'heading',
      '|',
      'bold',
      'italic',
      'underline',
      'code',
      'alignment',
      '|',
      'bulletedList',
      'numberedList',
      'indent',
      'outdent',
      '|',
      'link',
      'insertImage',
      'codeBlock',
      '|',
    ],
    shouldNotGroupWhenFull: true,
  },
  plugins: [
    Alignment,
    AutoImage,
    AutoLink,
    Autosave,
    Bold,
    Code,
    CodeBlock,
    Essentials,
    Heading,
    ImageBlock,
    ImageInsert,
    ImageInsertViaUrl,
    ImageToolbar,
    ImageUpload,
    Indent,
    IndentBlock,
    Italic,
    Link,
    List,
    Mention,
    Paragraph,
    PasteFromOffice,
    SelectAll,
    Underline,
    Undo,
  ],
  extraPlugins: [CodelyUploadAdapterPlugin],
  heading: {
    options: [
      {
        model: 'paragraph',
        title: 'Paragraph',
        class: 'ck-heading_paragraph',
      },
      {
        model: 'heading1',
        view: 'h1',
        title: 'Heading 1',
        class: 'ck-heading_heading1',
      },
      {
        model: 'heading2',
        view: 'h2',
        title: 'Heading 2',
        class: 'ck-heading_heading2',
      },
      {
        model: 'heading3',
        view: 'h3',
        title: 'Heading 3',
        class: 'ck-heading_heading3',
      },
      {
        model: 'heading4',
        view: 'h4',
        title: 'Heading 4',
        class: 'ck-heading_heading4',
      },
      {
        model: 'heading5',
        view: 'h5',
        title: 'Heading 5',
        class: 'ck-heading_heading5',
      },
      {
        model: 'heading6',
        view: 'h6',
        title: 'Heading 6',
        class: 'ck-heading_heading6',
      },
    ],
  },
  image: {
    toolbar: ['imageTextAlternative'],
  },
  // initialData: "<p>Hello, world!</p>",
  link: {
    addTargetToExternalLinks: true,
    defaultProtocol: 'https://',
    decorators: {
      toggleDownloadable: {
        mode: 'manual',
        label: 'Downloadable',
        attributes: {
          download: 'file',
        },
      },
    },
  },
  mention: {
    feeds: [
      {
        marker: '@',
        feed: [
          /* See: https://ckeditor.com/docs/ckeditor5/latest/features/mentions.html */
        ],
      },
    ],
  },
  placeholder: 'Type or paste your content here!',
};
let openModalsCount = 0;
let mode = {
  edit: false,
  p5jsData: null,
  compilerData: null,
};
const importImgVar = function (nameOf) {
  // Normalize 'imgactivity1' -> 'activity1', 'imgactivity1NoBg' -> 'activity1_nobg'
  let key = nameOf.replace(/^img/, '').replace(/NoBg$/, '_nobg');
  return activityImages[key] ?? null;
};

class CodelyUploadAdapter {
  constructor(loader) {
    this.loader = loader;
    this.abortController = new AbortController();
  }

  async upload() {
    const file = await this.loader.file;
    const result = await uploadCodelyFile(file, { signal: this.abortController.signal });
    if (!result?.publicUrl) {
      throw new Error('Codely file upload did not return a public URL.');
    }
    return {
      default: result.publicUrl,
    };
  }

  abort() {
    this.abortController.abort();
  }
}

function CodelyUploadAdapterPlugin(editorInstance) {
  editorInstance.plugins.get('FileRepository').createUploadAdapter = (loader) =>
    new CodelyUploadAdapter(loader);
}

const deleteIframeContent = function () {
  var iframe = document.getElementById('p5Iframe');

  // Check if the iframe element exists
  if (iframe) {
    // Check if the iframe has a parent element
    if (iframe.parentElement) {
      // Remove the iframe element from its parent
      iframe.parentElement.removeChild(iframe);
    }
  }
};
const closeModal = (e) => {
  const targetModal = e.target.closest('.modal-window');
  for (var i = 0; i < document.querySelectorAll('.modal-window').length; i++) {
    if (document.querySelectorAll('.modal-window')[i].style.display == 'block') {
      openModalsCount++;
    }
  }
  if (openModalsCount == 1) {
    targetModal.style.display = 'none';
    document.querySelector('.overlay').style.display = 'none';
  }
  if (openModalsCount > 1) {
    targetModal.style.display = 'none';
    openModalsCount = 0;
    return;
  }
  openModalsCount = 0;
};

const validateAddress = function (defaultPort = null) {
  let ipVal = document.querySelector('#input-ip').value;
  if (defaultPort) portVal = defaultPort;
  if (ipVal.length === 0) return null;
  return `https://${ipVal}:3000`;
};
const directShareLink = function (shareInstructionModal = null) {
  console.log('Direct share without instructions');
  if (window.location.pathname.split('.html')[0].slice(1).includes('sketch')) {
    sendToDatabase('share', null, null, JSON.stringify(mode.p5jsData));
  } else if (curPage.includes('compiler')) {
    sendToDatabase('share', null, null, JSON.stringify(mode.compilerData));
  } else {
    sendToDatabase('share');
  }
  if (shareInstructionModal) {
    shareInstructionModal.style.display = 'none';
    shareInstructionModal?.remove();
  }
};
const hidePageElements = function () {
  const visualisation = document.getElementById('visualisation');
  let blocklyDiv = document.getElementById('blocklyDiv');
  let moreBtn = document.querySelector('.more-button');
  let p5Iframe = document.getElementById('p5Iframe');
  let codeArea = document.querySelectorAll('.w3-code');
  let tab = document.querySelector('.tab');
  let dots = document.querySelector('.dots');
  let lvlDropdown = document.querySelector('.level-dropdown');
  let appHeaderTrigger = document.querySelector('.app-header__trigger');
  [blocklyDiv, dots, lvlDropdown, moreBtn, ...codeArea, tab, appHeaderTrigger].forEach((el) => {
    if (el == null) return;
    el.style.display = 'none';
  });
  visualisation?.classList.remove('visDefault');
  visualisation?.classList.add('visFixed');
  p5Iframe?.classList.add('p5fixed');
  p5Iframe?.classList.remove('p5default');
};

export const extractClassNamesForPythonFactory = (xml) => {
  const parser = new DOMParser();

  // Parse the XML code
  const xmlDoc = parser.parseFromString(xml, 'text/xml');

  // Find all field elements with name="class_name" inside class_block elements
  const classBlocks = xmlDoc.querySelectorAll('block[type="class_block"]');

  // Extract the field values
  const classNames = Array.from(
    classBlocks,
    (block) => block.querySelector('field[name="class_name"]').textContent
  );
  if (classNames.length > 0) {
    classNames.forEach((el) => classNameObj.classBlocksData.push([el, el]));
  }
};
const sendToDatabase = async function (
  methodType = 'share',
  arg1,
  arg2,
  dataToAdd = null,
  instruction
) {
  try {
    let createShareData;
    const params = new URLSearchParams(window.location.search);
    const levelParam = params.get('level');

    const levelPath = `${window.location.pathname.split('/').pop()}${
      levelParam ? `?level=${levelParam}` : ''
    }`;

    if (dataToAdd) {
      createShareData = dataToAdd;
    } else if (!curPage.includes('activities_saved')) {
      createShareData = buildShareDataForCurrentPage();
    }

    let requestUrl = apiRoutes.codelyShares();
    let requestMethod = 'POST';
    if (methodType === 'publish2') {
      requestUrl = apiRoutes.codelySharePublication(arg1);
      requestMethod = 'PUT';
    }
    const requestOptions = {
      method: requestMethod,
      headers: {
        'Content-Type': 'application/json',
      },
    };
    if (methodType !== 'publish2') {
      requestOptions.body =
        methodType === 'share'
          ? JSON.stringify({
              data: `${createShareData}`,
              level: levelPath,
              instruction,
            })
          : JSON.stringify({
              data: `${createShareData}`,
              image: arg2,
              title: arg1,
              level: levelPath,
              publishNow: methodType === 'publish' ? true : null,
            });
    }
    let response = await authenticatedFetch(requestUrl, requestOptions);

    let receiveBack = await response.json();
    if (receiveBack.error) {
      throw 'Error';
    }
    if (methodType === 'share') {
      showShareDialog(receiveBack.shareId, levelParam);
    }
    if (methodType === 'publish') {
      showSuccessMsg(currLang['SucessMsg.Save&Publish'], null, false);
    }
    if (methodType === 'publish2') {
      showSuccessMsg(currLang['SucessMsg.Publish'], null, false);
      if (window.location.pathname.includes('activites1')) {
        window.location.reload();
      }
    }
    if (methodType === 'save') {
      showToast(currLang['SucessMsg.Save'], 'success');
    }
  } catch (err) {
    console.log(err);
    showErrorMsg(currLang['Game.ErrorText'], null, false);
  }
};
const requestFromDatabase = async function (data) {
  try {
    const content = await fetchCodelyShare(data);
    // console.log(content);
    const showCode = new URLSearchParams(window.location.search).get('showcode');
    if (!showCode) {
      hidePageElements();
    }
    let savedData = content.data;
    let instructions = content.instruction;
    if (instructions) {
      setAuthoredInstructionHtml(instructions);
    }
    if (savedData) {
      if (window.location.pathname.split('.html')[0].slice(1).includes('sketch')) {
        deleteIframeContent();
        let sketchData = JSON.parse(savedData);
        mode.p5jsData = sketchData;
        mode.p5jsData.forEach((el) => {
          console.log(el);
          updateCodeMirrorValue(el.textareaId, el.code);
          setCodeToTextArea(el.textareaId, el.code);
        });
        createIframeContent(mode.edit);
        return;
      } else if (window.location.pathname.split('.html')[0].slice(1).includes('compiler')) {
        let compileData = JSON.parse(savedData);
        mode.compilerData = compileData;
        mode.compilerData.forEach((el) => {
          console.log(el);
          updateCodeMirrorValue(el.textareaId, el.code);
          setCodeToTextArea(el.textareaId, el.code);
        });
        return;
      } else {
        if (
          location.href.includes('python_factory') ||
          location.href.includes('vernatics_factory') ||
          location.href.includes('vernatics_esp') ||
          location.href.includes('music_factory')
        ) {
          extractClassNamesForPythonFactory(savedData);
        }
        if (savedData.startsWith('<xml')) {
          let domString = Blockly.utils.xml.textToDom(savedData);
          // console.log("blockly_share_test", domString);
          Blockly.getMainWorkspace().clear();
          Blockly.Xml.domToWorkspace(domString, Blockly.getMainWorkspace());
        } else {
          intialCodeData = savedData;
        }
      }
    }
  } catch (err) {
    console.log(err);
    showErrorMsg(currLang['Game.ErrorText'], null, false);
  }
};
const searchOnDatabase = async function (method = null, el = document.querySelector('.cards')) {
  try {
    let testVariable = null;
    if (method == 'store') testVariable = true;
    let response = await authenticatedFetch(apiRoutes.codelyShares(testVariable), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const content = await response.json();
    let shareObj = content.shares;
    // console.log(content.shares);
    let curDomain = window.location.origin;
    let userHtmlString = '';
    shareObj.forEach((el) => {
      // Some share records come back missing image/title/level (backend
      // data issue — see conversation). importImgVar(undefined) used to
      // throw here, which aborted the forEach before el.innerHTML was
      // ever set below — silently blanking out ALL cards, not just the
      // malformed one. Skip malformed records instead of crashing.
      if (!el.image) {
        console.warn('Skipping malformed share record (missing image):', el.shareId);
        return;
      }
      let curImg = importImgVar(el.image);
      if (!curImg) return;
      let linkToActivity = `${curDomain}/${el.level}${
        el.level.includes('?') ? '&' : '?'
      }shared=${el.shareId}`;
      // console.log(linkToActivity);
      userHtmlString += `
      <li class="card_el box-appearance" data-share="${el.shareId}">
      <div class="img-desktop">
        <img src="${importImgVar(el.image)}"/>
      </div> 
      <div class="img-mobile">
        <img src="${importImgVar(el.image + 'NoBg')}"/>
      </div>
      <div class="details"> 
      <p><br>
        <span id="blocks-text"> ${el.title}</span>
      </p>
      <p>${currLang['Store.Author']}:<span id="blocks-text"> ${el.createdBy}</span></p> ${
        method == 'store'
          ? `<p > ${currLang['Store.Published']}: <span id='blocks-text'>` +
            (el.isPublished ? currLang['Activty.Yes'] : currLang['Activty.No']) +
            '</span></p>'
          : ''
      }   <button  class="button2 visit-btn" onclick="window.location.href = '${linkToActivity}'">  ${
        currLang['Home.labelVisit']
      }</button> ${
        el.isPublished == false
          ? `<button  class="button2 publish-btn" >${currLang['PublishButton.Text']}</button>`
          : ''
      }</div></li>`;
    });

    el.innerHTML = userHtmlString;
    addDesignToModal();
  } catch (err) {
    console.log(err);
  }
};

const categoryMap = {
  // Factory
  catVariables: 'Home.LevelLabel9',
  catFunctions: 'Home.LevelLabel8',
  catScene: 'Factory.Scene',
  catSprites: 'Factory.Sprites',
  catEvents: 'Factory.Events',
  catBehave: 'Factory.Behaviours',
  catLogic: 'Factory.Logics',
  catLoops: 'Factory.Loops',
  catMath: 'Factory.Math',
  catText: 'Factory.Text',
  catLists: 'Factory.Lists',
  catColour: 'Factory.Colour',
  catError: 'Factory.Error',
  catui: 'Factory.UI',

  // Web Factory
  catPage: 'Web.Page',
  catStruct: 'Web.Structure',
  listTags: 'Web.Lists',
  catForms: 'Web.Forms',
  catAttri: 'Web.Attributes',
  catText: 'Web.Text',

  // Media & Data
  catmusic: 'cat.Music',
  catMedia: 'cat.media',
  catTable: 'cat.table',
  catScript: 'cat.script',
  catDataStruct: 'cat.DataStruct',
  errorHandling: 'cat.errorHandling',
  class: 'cat.class',
  catData: 'cat.Data',
  catart: 'cat.Art',
  drawfunc: 'cat.Draw',

  // Vernatics / Hardware
  vernatics: 'v.vernatics',
  vcommon: 'v1.common',
  expertsLib: 'v.expertsLib',
  led_: 'v.led',
  color_led: 'v.color_led',
  door_bell: 'v.door_bell',
  motor: 'v.motor',
  seven_segment: 'v.seven_segment',
  traffic_light: 'v.traffic_light',
  traffic_light_detector: 'v.traffic_light_detector',
  line_follower: 'v.line_follower',
};

function updateToolboxTranslations() {
  const toolbox = document.querySelector('#toolbox');
  Object.entries(categoryMap).forEach(([id, langKey]) => {
    const el = document.querySelector(`#${id}`);
    if (el) el.setAttribute('name', currLang[langKey]);
  });

  if (toolbox) Blockly.getMainWorkspace().updateToolbox(toolbox);
}

const loadingThisScriptAfterPageLoad = function () {
  updateToolboxTranslations();
  if (
    curPage.includes('index') ||
    // curPage.includes("dragndrop") ||
    curPage == ''
  )
    return;
  updateToolboxTranslations();

  let moreBtn = document.createElement('button');
  moreBtn.classList.add('more', 'more-button');

  let moreBtnHtml = `
   <text class="control-btn"><span class="btn-label">${currLang['MoreButton.Text']}</span><i data-lucide="circle-ellipsis" stroke="#e2d368"></i></text>`;
  moreBtn.innerHTML = moreBtnHtml;

  const toolbar = document.getElementById('toolbar');
  const stopBtn = toolbar.querySelector('.stop');

  if (stopBtn) {
    toolbar.insertBefore(moreBtn, stopBtn.nextSibling);
  } else {
    // Fallback if .stop doesn't exist
    toolbar.appendChild(moreBtn);
  }
  const vernaticsModal = location.href.includes('vernatics_factory')
    ? createVernaticsModal({ currLang, validateAddress })
    : null;
  const moreModal = setupGameModals({
    currLang,
    importImgVar,
    sendToDatabase,
    mode,
    curPage,
    editorConfig,
    showErrorMsg,
    updateToolboxTranslations,
    onCodeButtonClick: vernaticsModal ? vernaticsModal.open : undefined,
    workspace: Blockly.getMainWorkspace(),
  });
  console.log();
  moreBtn.addEventListener('click', () => {
    moreModal.open();
  });

  if (location.href.includes('vernatics_factory')) {
    const vernaticsModal = createVernaticsModal({ currLang, validateAddress });
    vernaticsModal.open();
  } else {
    let langDropdown = document.getElementById('languageDropdown');
    if (langDropdown) langDropdown.style.display = 'block';
  }
  addDesignToModal();
  var workspace = Blockly?.getMainWorkspace();
  workspace?.addChangeListener(updateCode);
  //set intial blocks
  if (blocksData) {
    blocksData = Blockly.Xml.workspaceToDom(Blockly.getMainWorkspace(), true);
    blocksData = Blockly.Xml.domToText(blocksData);
  }

  function fixBlocklyLayout() {
    const ws = Blockly?.getMainWorkspace?.();
    if (!ws) return;
    try {
      Blockly.svgResize(ws);
      ws.resize();
    } catch (err) {
      console.warn('[layout-fix] Blockly resize failed:', err);
    }
  }

  window.addEventListener('load', () => {
    requestAnimationFrame(() => requestAnimationFrame(fixBlocklyLayout));
    initializeWorkspaceScrollbarVisibility(
      Blockly.getMainWorkspace(),
      document.getElementById('blocklyDiv')
    );
    const instructParent = document.querySelector('.instruct-parent');
    instructParent.classList.add('animate');
  });
  if (window.location.hostname.includes('portal')) console.clear(); //Remove in case of any bugs
};
document.body.addEventListener('click', function (e) {
  if (e.target.closest('.close-btn')) {
    closeModal(e);
  }
});
const turnOnSwitch = function (val) {
  if (!location.href.includes('data_Simulation')) {
    let toggleCheckbox = document.getElementById('checkbox');

    if (toggleCheckbox !== null) {
      toggleCheckbox.checked = val;
    }
  }
};
const checkNavActive = function () {
  const hideElementsNotRequired = function () {
    let elList = [
      'app-header__trigger',
      'nav-bar',
      'next-level',
      'save-button',
      'publish-button',
      'translate-button',
      'profile-btn',
    ];
    elList.forEach((el) => {
      let elRef = document.querySelector(`.${el}`);
      if (!elRef) return;
      elRef.style.display = 'none';
    });
    if (document.querySelector('.button-container')) {
      document.querySelector('.button-container').style.gridTemplateColumns = 'repeat(1,1fr)';
    }
  };
  //check navAvtive
  const params = new URLSearchParams(window.location.search);
  const shownavParam = params.get('shownav'); // "false" when embedded in iframe

  const checkNav = shownavParam !== 'false';

  let checkWebview = sessionStorage.getItem('webviewActive');
  if (checkWebview) {
    if (!sessionStorage.getItem('practicePage')) {
      hideElementsNotRequired();
    }
    return;
  }
  if (!checkNav) {
    hideElementsNotRequired();
  }
};
function buildShareDataForCurrentPage() {
  if (curPage.includes('sketch')) {
    return JSON.stringify(mode.p5jsData || []);
  }
  if (curPage.includes('compiler')) {
    return JSON.stringify(mode.compilerData || []);
  }
  const currentDom = Blockly.Xml.workspaceToDom(Blockly.getMainWorkspace(), true);
  const currentText = Blockly.Xml.domToText(currentDom);
  if (currentText === blocksData) {
    const codeContainer = document.querySelector('#code-container');
    return codeContainer.value;
  }
  return Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(Blockly.getMainWorkspace()));
}
const onPageLoadFireThis = function () {
  const params = new URLSearchParams(window.location.search);
  const sharedId = params.get('shared');
  const showCode = params.get('showcode') === 'true';
  if (sharedId && !showCode) {
    mode.edit = false;
    let editBtn = document.createElement('button');
    editBtn.classList.add('edit', 'edit-button', 'button', 'toolbar-btn');
    editBtn.innerHTML = `<text class="control-btn"><span class="btn-label">${currLang['Share.ShowCode']}</span><i data-lucide="code"></i></text>`;
    document.getElementById('toolbar').appendChild(editBtn);
    let checkWebview1 = sessionStorage.getItem('webviewActive');
    if (checkWebview1) {
      let finishBtn = document.createElement('button');
      finishBtn.classList.add('finish', 'finish-button', 'button');
      finishBtn.textContent = currLang['Share.Finish'];
      document.body.appendChild(finishBtn);
      finishBtn.addEventListener('click', function () {
        sendBack(JSON.stringify({ type: 'result', body: 'success' }));
      });
    }
    hidePageElements();
    //CHange arroy keys position
    document
      .getElementById('arrow-button-container')
      ?.classList.add('arrow-button-container-playable');
    turnOnSwitch(false);
    let toggleDropdownModes = document.querySelector('.pane-toggle-trigger');
    if (toggleDropdownModes) toggleDropdownModes.style.display = 'none';
    checkNavActive();
    editBtn.addEventListener('click', function () {
      turnOnSwitch(true);
      document
        .getElementById('arrow-button-container')
        ?.classList.remove('arrow-button-container-playable');
      let codeEditorContainer = document.getElementById('code-container');
      if (codeEditorContainer) {
        // Populate the textarea (use .value for <textarea> / <input>) and sync any attached editor
        if (intialCodeData) {
          if ('value' in codeEditorContainer) {
            codeEditorContainer.value = intialCodeData;
          } else {
            // fallback for non-form elements
            codeEditorContainer.innerText = intialCodeData;
          }

          // If a code editor (e.g., CodeMirror/Monaco) is attached as window.editor, update it too
          if (window.editor && typeof window.editor.setValue === 'function') {
            try {
              window.editor.setValue(intialCodeData);
              if (!curPage.includes('vernatics') && typeof window.formatCode === 'function') {
                window.formatCode(window.editor);
              }
              if (typeof window.editor.refresh === 'function') window.editor.refresh();
            } catch (err) {
              console.error('Error updating attached editor:', err);
            }
          }

          // Notify listeners that the value changed
          codeEditorContainer.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
      if (window.location.pathname.split('.html')[0].slice(1).includes('sketch')) {
        let codeArea = document.querySelector('#sketchTextarea');
        let tab = document.querySelector('.tab');

        if (tab) tab.style.display = 'block';
        openTab(
          { currentTarget: document.getElementById('sketchTextareaButton') },
          'sketchTextarea'
        );
        codeArea.style.display = 'block';
        const p5Iframe = document.getElementById('p5Iframe');
        p5Iframe?.classList.add('p5default');
        p5Iframe?.classList.remove('p5fixed');
      } else {
        AppShell.switchToEdit();
        let blocklyDiv = document.getElementById('blocklyDiv');
        if (blocklyDiv) blocklyDiv.style.display = 'block';
        Blockly.getMainWorkspace()?.render();
        window.dispatchEvent(new Event('resize'));
      }
      document.querySelector('.more-button').style.display = 'block';
      toggleDropdownModes.style.display = 'block';
      editBtn.remove();
      mode.edit = true;
      if (location.href.includes('factory') && window.innerWidth < 720)
        if (location.href.includes('vernatics_esp')) {
        }
      // let switchEl = document.querySelector(".switch");
      // if (switchEl) switchEl.style.display = "block";
    });
    sendBack(JSON.stringify({ type: 'page_event', body: 'content_loaded' }));
  }
  checkNavActive();
  createIcons({
    icons,
    attrs: {
      width: 16,
      height: 16,
    },
  });
  const exportBtn = document.getElementById('export-btn');
  if (exportBtn) {
    exportBtn.addEventListener('click', function () {
      const queryParams = new URLSearchParams(window.location.search);

      const paramsArray = [...queryParams.entries()].map(([key, value]) => ({
        key,
        value,
      }));

      const createShareData = buildShareDataForCurrentPage();

      const shareObject = {
        page: curPage,
        params: paramsArray,
        data: createShareData,
      };

      const shareModal = createShareModal(() => ({
        title: 'Export Data',
        text: JSON.stringify(shareObject, null, 2),
        actionLabel: 'Generate link',
        actionDoneLabel: 'Link generated',
        actionIcon: icons.Link,
        showTextPreview: false,
        onAction: async ({ text }) => {
          const result = await uploadCodelyFile(createJsonFile(text, exportFileName(curPage)));
          if (!result?.publicUrl) {
            throw new Error('Codely file upload did not return a public URL.');
          }
          return { link: result.publicUrl };
        },
        extraField: {
          label: 'Add instruction',
          placeholder: 'Type an instruction…',
          initialValue: getAuthoredInstructionHtml(),
          editor: { ClassicEditor, config: editorConfig },
          buildText: (value) => JSON.stringify({ ...shareObject, instruction: value }, null, 2),
        },
      }));
      shareModal.open();
    });
  }
  const importBtn = document.getElementById('import-btn');
  if (importBtn) {
    importBtn.addEventListener('click', function () {
      createImportActivityModal().open();
    });
  }
  console.log('icons created');
};

function createImportActivityModal() {
  return createModal({
    title: 'Import Activity',
    closable: true,
    size: 'md',
    content: () => {
      const wrapper = document.createElement('div');
      wrapper.className = 'share-modal';

      const label = document.createElement('label');
      label.className = 'share-modal__toggle-row';
      label.htmlFor = 'codely-import-activity-url';
      label.textContent = 'Exported activity link';

      const input = document.createElement('input');
      input.id = 'codely-import-activity-url';
      input.type = 'url';
      input.className = 'share-modal__extra-input';
      input.placeholder = 'https://.../codely-files/.../activity.json';
      input.autocomplete = 'off';

      const status = document.createElement('div');
      status.className = 'share-modal__result';
      status.hidden = true;

      const statusLabel = document.createElement('span');
      statusLabel.className = 'share-modal__result-label';
      statusLabel.textContent = 'Import status';

      const statusText = document.createElement('span');
      statusText.className = 'share-modal__result-link';
      status.appendChild(statusLabel);
      status.appendChild(statusText);

      const action = document.createElement('button');
      action.type = 'button';
      action.className = 'share-modal__action';
      action.textContent = 'Open activity';

      const showStatus = (message) => {
        statusText.textContent = message;
        status.hidden = false;
      };

      action.addEventListener('click', () => {
        try {
          const launchUrl = buildCodelyLaunchUrl(input.value);
          action.disabled = true;
          action.textContent = 'Opening...';
          window.location.href = launchUrl;
        } catch (err) {
          showStatus(err?.message || 'Activity link is invalid.');
        }
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          action.click();
        }
      });

      wrapper.appendChild(label);
      wrapper.appendChild(input);
      wrapper.appendChild(status);
      wrapper.appendChild(action);
      setTimeout(() => input.focus(), 0);
      return wrapper;
    },
  });
}
function addFunctionNames() {
  let allBlocks = Blockly.getMainWorkspace().getAllBlocks(true);
  functionNameObj.functionBlocksData = [];
  allBlocks.forEach((el) => {
    let fName = el.getFieldValue('NAME');
    if (fName) {
      if (functionNameObj.functionBlocksData.filter((el) => el.includes(fName)).length > 0) {
        return;
      } else {
        functionNameObj.functionBlocksData.push([fName, fName]);
      }
    }
  });
  // console.log(functionNameObj);
}
function addImports(code = null, workspace) {
  if (!code) return null;
  var imports = '';
  var blocks = workspace.getAllBlocks();
  let curCode = code;

  // ── Handle Vernatics ESP blocks (BLE-based) ──
  if (location.href.includes('vernatics_esp')) {
    const blockTypes = blocks.map((block) => block.type);
    const machineImports = new Set();
    const standardImports = new Set();

    // ── Declarative import map ────────────────────────────────────────────────
    // Each row: [ [blockTypes...], [machine imports...], [standard imports...] ]
    // Add a new row here whenever a new ESP block needs imports — no if/else needed.
    const espBlockImportMap = [
      // ── Simple Pin + time blocks ──
      [
        [
          'led_blink_esp_block',
          'led_morse_sos_esp_block',
          'motor_square_esp_block',
          'buzzer_button_esp_block',
          'ir_sensor_esp_block',
          'pin_setup_esp_block',
          'delay_esp_block',
          'buzzer_beep_esp_block',
          'buzzer_pattern_esp_block',
          'buzzer_ir_esp_block',
          // Medium level — Pin + time
          'led_setup_medium_block',
          'led_blink_loop_medium_block',
          'morse_sos_setup_medium_block',
          'morse_sos_helpers_medium_block',
          'morse_sos_loop_medium_block',
          'motor_square_setup_medium_block',
          'motor_square_run_medium_block',
          'lf_pin_setup_medium_block',
          'lf_define_moves_medium_block',
          'lf_run_loop_medium_block',
          'lf_dual_moves_medium_block',
          'lf_dual_run_medium_block',
          'ir_led_setup_medium_block',
          'ir_blink_run_medium_block',
          'buzzer_setup_medium_block',
          'buzzer_button_loop_medium_block',
          'buzzer_ir_setup_medium_block',
          'buzzer_ir_loop_medium_block',
        ],
        ['Pin'],
        ['time'],
      ],

      // ── Pin + PWM + time blocks ──
      [
        [
          'motor_setup_esp_block',
          'run_motor_esp_block',
          'servo_sweep_esp_block',
          'motor_speed_esp_block',
          'pwm_setup_esp_block',
          'servo_motor_esp_block',
          'buzzer_melody_esp_block',
          'line_follower_esp_block',
          // Medium level — Pin + PWM + time
          'left_motor_setup_medium_block',
          'right_motor_setup_medium_block',
          'motor_pwm_setup_medium_block',
          'motor_run_medium_block',
          'servo_setup_medium_block',
          'servo_sweep_medium_block',
          'servo_smooth_setup_medium_block',
          'servo_smooth_sweep_medium_block',
          'buzzer_melody_setup_medium_block',
          'buzzer_melody_choose_medium_block',
          'buzzer_melody_play_medium_block',
        ],
        ['Pin', 'PWM'],
        ['time'],
      ],

      // ── Pin + SoftI2C + ssd1306 (OLED) blocks ──
      [
        [
          'oled_display_esp_block',
          'oled_text_wrap_esp_block',
          'oled_text_esp_block',
          // Medium level — OLED
          'oled_setup_medium_block',
          'oled_show_text_medium_block',
          'oled_wrap_text_medium_block',
        ],
        ['Pin', 'SoftI2C'],
        ['ssd1306'],
      ],

      // ── Pin + SoftI2C + ssd1306 + time (IR + OLED combo) blocks ──
      [
        [
          'ir_counter_oled_esp_block',
          'ir_live_status_oled_esp_block',
          // Medium level — IR counter/display with OLED
          'ir_counter_setup_medium_block',
          'ir_counter_display_medium_block',
          'ir_counter_run_medium_block',
          'ir_live_status_medium_block',
        ],
        ['Pin', 'SoftI2C'],
        ['time', 'ssd1306'],
      ],
      // ── Ultrasonic Sensor — Pin + UART + I2C + ssd1306 + time ──
      [['ultrasonic_obstacle_avoid_medium_block'], ['Pin', 'UART', 'I2C'], ['time', 'ssd1306']],
    ];
    // ─────────────────────────────────────────────────────────────────────────

    espBlockImportMap.forEach(([espBlocks, machine, standard]) => {
      if (espBlocks.some((t) => blockTypes.includes(t))) {
        machine.forEach((m) => machineImports.add(m));
        standard.forEach((s) => standardImports.add(s));
      }
    });

    // Only add imports that don't already exist in the generated code
    const hasMachineImport = curCode.includes('from machine import');
    const hasTimeImport = curCode.includes('import time');
    const hasSsd1306Import = curCode.includes('import ssd1306');
    const hasOtaWifiImport = curCode.includes('import ota_wifi');
    const hasWsClientImport = curCode.includes('import ws_client');
    const hasOtaBleImport = curCode.includes('import ota_ble');

    if (machineImports.size > 0 && !hasMachineImport) {
      imports += `from machine import ${Array.from(machineImports).join(', ')}\n`;
    }
    if (standardImports.has('time') && !hasTimeImport) imports += `import time\n`;
    if (standardImports.has('ssd1306') && !hasSsd1306Import) imports += `import ssd1306\n`;
    if (!hasOtaWifiImport && imports) imports += `import ota_wifi\n`;
    if (!hasWsClientImport && imports) imports += `import ws_client \n`;
    if (!hasOtaBleImport && imports) imports += `import ota_ble\n`;

    if (imports) return imports + '\n' + curCode;
    return null;
  }

  // ── Original APT library import handling ──
  // Check for specific blocks and add corresponding imports
  const checkBlockWithoutType = function (blockType, output, importInput) {
    var hasGivenBlock = blocks.some((block) => block.type == blockType);
    let importName = 'APT';
    if (importInput) {
      importName = importInput;
    }
    if (
      hasGivenBlock &&
      !curCode.includes(`from ${importName} import ${output}`) &&
      !imports.includes(`from ${importName} import ${output}`)
    ) {
      imports += `from ${importName} import ${output} \n`;
    }
  };
  const checkBlockWithType = function (blockType, importInput) {
    let importName = 'APT';
    if (importInput) {
      importName = importInput;
    }
    var hasGivenBlock = blocks.find((block) => block.type == blockType);
    if (hasGivenBlock) {
      let type = hasGivenBlock.getFieldValue('type');
      if (hasGivenBlock.type === 'function_pointer_block') {
        type = hasGivenBlock.getFieldValue('pointer');
        type = type.split('.')[0];
      }
      if (
        type &&
        !curCode.includes(`from ${importName} import ${type}`) &&
        !imports.includes(`from ${importName} import ${type}`)
      ) {
        imports += `from ${importName} import ${type} \n`;
      }
    }
  };
  let blocksWithoutType = [
    ['color_led_block', 'color_led'],
    ['run_motor_block', 'motor'],
    ['seven_segment_block', 'seven_segment'],
    ['seven_segment_setup_block', 'seven_segment'],
    ['seven_segment_turnoff_block', 'seven_segment'],
    ['seven_segment_counter_block', 'seven_segment'],
    ['seven_segment_displaytext_block', 'seven_segment'],
    ['door_bell_block', 'doorBell'],
    ['thread_start_block', 'Thread', 'threading'],
    ['thread_block', 'Thread', 'threading'],
    ['on_off_block', 'DigitalOutputDevice', 'gpiozero'],
    ['two_value_block', 'PWMOutputDevice', 'gpiozero'],
    ['is_active_block', 'DigitalInputDevice', 'gpiozero'],
    ['traffic_light_block', 'traffic_light'],
    ['color_palette_block', 'colour_palette'],
    ['line_follower_block', 'line_follower'],
    ['line_follower_block2', 'line_follower'],
    ['smart_follower_block', 'smart_follower'],
    ['smart_follower_block2', 'smart_follower'],
    ['run_setup_block', 'line_follower'],
    ['run_setup_block2', 'line_follower'],
    ['traffic_light_detector_block', 'traffic_signal'],
  ];
  let blocksWithType = [
    ['blink_beep_block'],
    ['loudness_brightness_block'],
    ['change_brightness_loudness_block'],
    // ["function_pointer_block"],
    ['io_device_block', 'gpiozero'],
  ];
  blocksWithoutType.forEach((el) => checkBlockWithoutType(el[0], el[1], el[2]));
  blocksWithType.forEach((el) => checkBlockWithType(el[0], el[1]));

  // Add imports at the beginning of the curCode
  return imports + '\n' + curCode;
}
const updateCode = () => {
  try {
    var workspace = Blockly.getMainWorkspace();
    var code = '';
    const isFactoryLikePage =
      location.href.includes('factory') || location.href.includes('vernatics_esp');

    if (!isFactoryLikePage) return;
    if (
      !(
        location.href.includes('python_factory') ||
        location.href.includes('vernatics_factory') ||
        location.href.includes('vernatics_esp')
      )
    ) {
      code = JsGenerator.javascriptGenerator.workspaceToCode(workspace);
      code = code.replaceAll('# ', '');
    } else code = pythonGenerator.workspaceToCode(workspace);
    let codeContainer;
    if (!isFactoryLikePage) codeContainer = document.getElementById('codeHolder');
    else codeContainer = document.getElementById('code-container');
    if (codeContainer) {
      codeContainer.innerHTML = ''; // Delete old code.
      if (!isFactoryLikePage) codeContainer.appendChild(document.createTextNode(code));
      else {
        if (
          location.href.includes('python_factory') ||
          location.href.includes('vernatics_factory') ||
          location.href.includes('vernatics_esp')
        ) {
          let imports = addImports(code, Blockly.getMainWorkspace());
          if (imports) code = imports;
          addFunctionNames();
        }
        codeContainer.value = code;
        loadedCdn
          .then(() => {
            window.editor.setValue(code);
            if (!curPage.includes('vernatics')) {
              window.formatCode(window.editor);
            }
            setTimeout(function () {
              window.editor.refresh();
            }, 1);
          })
          .catch((error) => {
            console.error('Error loading CDNs:', error);
          });
      }
    }
  } catch (error) {
    console.log(error);
  }
  w3CodeColor();
};
// onPageLoadFireThis();
export {
  sendToDatabase,
  requestFromDatabase,
  onPageLoadFireThis,
  loadingThisScriptAfterPageLoad,
  hidePageElements,
  searchOnDatabase,
  updateCode,
  deleteIframeContent,
  mode,
  validateAddress,
};
// if (document.readyState !== "loading") {
//   loadingThisScriptAfterPageLoad();
//   onPageLoadFireThis();
// } else {
//   document.addEventListener("DOMContentLoaded", function () {
//     loadingThisScriptAfterPageLoad();
//     onPageLoadFireThis();
//   });
// }
